import Image from "next/image";
import Link from "next/link";

export default function Footer() {
  return (
    <footer className="bg-surface text-surface-foreground py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-start">
          <div className="md:col-span-2">
            <Link href="/" className="inline-flex items-center mb-4">
              <Image src="/images/rounded-logo.png" alt="Hirecarta" width={48} height={48} className="w-12 h-12" />
            </Link>
            <p className="text-sm text-muted-foreground max-w-md">
              Hirecarta™ is an AI-native, end-to-end job application platform that helps you land your ideal role, delivering AI-powered career insights and application management to tailored resumes, interview prep, and virtual career coaching.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-4">Features</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/blog/ai-resume-builder" className="hover:text-foreground">
                  AI Resume Builder
                </Link>
              </li>
              <li>
                <Link href="/features#job-search" className="hover:text-foreground">
                  AI Job Search
                </Link>
              </li>
              <li>
                <Link href="/features#job-application" className="hover:text-foreground">
                  AI Job Application
                </Link>
              </li>
              <li>
                <Link href="/features#ats-checker" className="hover:text-foreground">
                  ATS Resume Checker
                </Link>
              </li>
              <li>
                <Link href="/jobfit-report" className="hover:text-foreground">
                  Job Fit Report
                </Link>
              </li>
              <li>
                <Link href="/resume-check" className="hover:text-foreground">
                  Free Resume Evaluation
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-4">Blog</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/blog" className="hover:text-foreground">
                  All Posts
                </Link>
              </li>
              <li>
                <Link href="/blog/the-truth-about-ats-scores" className="hover:text-foreground">
                  The Truth About ATS Scores
                </Link>
              </li>
              <li>
                <Link href="/blog/how-recruiters-use-ats" className="hover:text-foreground">
                  How Recruiters Actually Use ATS
                </Link>
              </li>
              <li>
                <Link href="/blog/job-search-tools-guide" className="hover:text-foreground">
                  Guide to Job Search Tools
                </Link>
              </li>
              <li>
                <Link href="/blog/why-ai-resume-writers-lie" className="hover:text-foreground">
                  Why AI Resume Writers Lie
                </Link>
              </li>
              <li>
                <Link href="/blog/jobscan-review" className="hover:text-foreground">
                  Jobscan Review and Alternatives
                </Link>
              </li>
              <li>
                <Link href="/blog/jobright-review" className="hover:text-foreground">
                  Jobright Review and Alternatives
                </Link>
              </li>
              <li>
                <Link href="/blog/rezi-review" className="hover:text-foreground">
                  Rezi Review and Alternatives
                </Link>
              </li>
              <li>
                <Link href="/blog/teal-review" className="hover:text-foreground">
                  Teal Review and Alternatives
                </Link>
              </li>
              <li>
                <Link href="/features" className="hover:text-foreground">
                  Compare features
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-4">Hirecarta</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/pricing" className="hover:text-foreground">
                  Pricing
                </Link>
              </li>
              <li>
                <Link href="/events" className="hover:text-foreground">
                  Events
                </Link>
              </li>
              <li>
                <Link href="/partners" className="hover:text-foreground">
                  Affiliate program
                </Link>
              </li>
              <li>
                <Link href="/support" className="hover:text-foreground">
                  Contact us
                </Link>
              </li>
              <li>
                <Link href="/faq" className="hover:text-foreground">
                  FAQ
                </Link>
              </li>
              <li>
                <Link href="/about" className="hover:text-foreground">
                  About
                </Link>
              </li>
              <li>
                <Link href="/my_story" className="hover:text-foreground">
                  Founder&apos;s Story
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-muted-foreground/20 pt-6 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-muted-foreground">&copy; {new Date().getFullYear()} Hirecarta. All rights reserved.</div>

          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <div className="flex items-center space-x-4">
              <Link
                href="https://x.com/hirecarta"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Follow us on X (Twitter)"
              >
                <Image src="/images/x.svg" alt="X (Twitter)" width={20} height={20} className="w-5 h-5" />
              </Link>

              <Link
                href="https://www.youtube.com/@Hirecarta"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Subscribe to our YouTube channel"
              >
                <Image src="/images/youtube.svg" alt="YouTube" width={20} height={20} className="w-5 h-5" />
              </Link>
            </div>

            <div className="flex items-center space-x-4">
              <Link href="/terms" className="text-sm text-muted-foreground hover:text-foreground">
                Terms of Service
              </Link>
              <Link href="/privacy" className="text-sm text-muted-foreground hover:text-foreground">
                Privacy policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
